import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { CommonConfig } from '../../../configs/config.common';
import { AxiosPromise } from '../../../utils/axios.promise';

@Component
export default class MarketingWatchPage extends Vue {
    public images: string[] = [];
    public lang: string | null = null;
    public configs = new CommonConfig();

    public async created() {
        const language = this.$route.query['ltype'];
        if (language) {
            this.lang = language[0];
            const url = `${this.configs.serverlessAPI}/marketing/client/home/marketing_watch?ltype=${this.lang}`;
            const fetched = await AxiosPromise.get(url);
            console.log(fetched);
            if (fetched.code === 200) {
                this.images = fetched.data.contentImages.split('|');
                console.log(this.images);
            }
        }

    }

    public mounted() {
    }
}
